module.exports = __webpack_public_path__ + "img/menu-board-double-pizza.bb1253ea.jpg";